export default function HeroSection() {
  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.75), rgba(13, 148, 136, 0.65)), url('https://public.readdy.ai/ai/img_res/33be9859df0198a5a3b10d2b438654ff.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center space-x-2 bg-teal-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-global-line text-teal-300"></i>
            <span className="text-teal-100 text-sm font-medium">Votre Partenaire de Confiance</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Ouvrez la Porte à Vos Opportunités Internationales
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Accompagnement professionnel pour tous vos projets de visa et d'immigration. Expertise, clarté et résultats garantis.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a 
              href="#contact" 
              className="bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 text-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Consultation Gratuite
            </a>
            <a 
              href="#services" 
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full hover:bg-white/20 transition-all font-semibold text-lg border-2 border-white/30 text-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-service-line mr-2"></i>
              Nos Services
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">98%</div>
              <div className="text-white/90 font-medium">Taux de Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">500+</div>
              <div className="text-white/90 font-medium">Visas Obtenus</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20">
              <div className="text-4xl font-bold text-teal-300 mb-2">10+</div>
              <div className="text-white/90 font-medium">Années d'Expérience</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#services" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </a>
      </div>
    </section>
  );
}
